module.exports = __webpack_public_path__ + "static/media/Compass_direction.984253b3.svg";